exports.list = {
    path: '/laporan_piutang_karyawan',
    name: 'laporan_piutang_karyawan', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_piutang_karyawan/List.vue"),
  }
  